// Optional user-supplied metadata attached to an assessment on creation/edit
export const ASSESSMENT_NAME_MAX_LENGTH = 80;
export const ASSESSMENT_NOTES_MAX_LENGTH = 500;

export const FLOORS = [
  { value: "ΥΠΟΓΕΙΟ", labelKey: "floors.basement" },
  { value: "ΗΜΙΥΠΟΓΕΙΟ", labelKey: "floors.semiBasement" },
  { value: "ΙΣΟΓΕΙΟ", labelKey: "floors.ground" },
  { value: "ΗΜΙΟΡΟΦΟΣ", labelKey: "floors.upperGround" },
  { value: "1", labelKey: "floors.floor1" },
  { value: "2", labelKey: "floors.floor2" },
  { value: "3", labelKey: "floors.floor3" },
  { value: "4", labelKey: "floors.floor4" },
  { value: "5", labelKey: "floors.floor5" },
];

//TODO: Refactor backend in order to return unique keys
export const RISK_MESSAGE_COLOR_MAP = {
  "Very low risk": "#2ECC71", // Green (Safe)
  "Πολύ χαμηλός κίνδυνος": "#2ECC71", // Green (Safe)
  "Low risk": "#28B463", // Slightly darker green
  "Χαμηλός κίνδυνος": "#28B463", // Slightly darker green
  "Medium risk": "#E67E22", // Orange (Warning)
  "Moderate risk": "#E67E22", // Orange (Warning)
  "Μέτριος κίνδυνος": "#E67E22", // Orange (Warning)
  "Elevated risk": "#D35400", // Dark orange (Elevated)
  "Αυξημένος κίνδυνος": "#D35400", // Dark orange (Elevated)
  "High risk": "#f82a2a", // Bright red
  "Υψηλός κίνδυνος": "#f82a2a", // Bright red
  "Very High risk": "#b70606", // Dark red
  "Very high risk": "#b70606", // Dark red
  "Πολύ υψηλός κίνδυνος": "#b70606", // Dark red
};

export const LOCAL_STORAGE_DEMO_PRIVATE_KEY = "demo_private_key";
export const LOCAL_STORAGE_MEMBER_AUTH_SESSION = "member_auth_session";

export const PERMISSIONS = {
  RISK_MAP: "risk_map",
  MUNICIPALITY_RISK_MAP: "municipality_risk_map",
  PORTFOLIO: "portfolio",
  MUNICIPALITY_PORTFOLIO: "municipality_portfolio",
  PORTFOLIO_EXPLORER: "portfolio_explorer",
};
